<template>
    <fade-animation :element="() => $refs.section">
        <div class="content-divider-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <hr v-test:contentDivider>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-animation>
</template>

<script>
    export default {
        name: 'content-divider-section',
    };
</script>

<style lang="scss" scoped>
    .content-divider-section {
        padding: 40px 0;

        @include media-breakpoint-up(md) {
            padding: 50px 0;
        }
    }

    hr {
        border-top: 3px solid secondary-palette(7);
        margin: 0;
    }
</style>
